import { navigateTo, useRoute } from "@app/lib/router.ts";
import { useViewMode } from "@app/lib/viewMode.tsx";

export function ViewModeToggle() {
  const [mode, setMode] = useViewMode();
  const route = useRoute();

  // Label by what's *actually visible*, not just the stored mode. When you're
  // in the Reader (route=doc) the user is reading text, even if the stored
  // mode is "3d" — the toggle should advertise the action that returns them
  // to the 3D world, not "Exit 3D".
  const isShowing3D = mode === "3d" && route.kind === "landing";

  const onClick = (): void => {
    if (isShowing3D) {
      setMode("2d");
      // Stay on landing — Landing will now render the 2D list.
    } else {
      setMode("3d");
      if (route.kind !== "landing") {
        navigateTo({ kind: "landing" });
      }
    }
  };

  const label = isShowing3D ? "Exit 3D" : "Open 3D library";
  // aria-label must start with the visible text (WCAG SC 2.5.3 Label in Name)
  // so voice-control users saying the visible label can target the button.
  const aria = isShowing3D ? "Exit 3D library view" : "Open 3D library view";

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={aria}
      aria-pressed={mode === "3d"}
      className="px-3 py-1.5 border border-chain-500/40 bg-chain-600/20 hover:bg-chain-600/40 rounded font-mono text-xs"
    >
      {label}
    </button>
  );
}
